import Market from '@/creditflowresearch/domain/Market';
import EmergingMarket from '@/creditflowresearch/domain/Market/entities/EmergingMarket';
import IgcProduct from '@/creditflowresearch/domain/Product/entities/IgcProduct';
import HycProduct from '@/creditflowresearch/domain/Product/entities/HycProduct';

export const buildQueryParams = (query: Record<string, any>) => {
  const { products, regions, segments, markets } = query;

  const params: Record<string, string> = {};

  if (products?.length) params.products = String(products);
  if (regions?.length) params.regions = String(regions);
  if (segments?.length) params.segments = String(segments);
  if (markets?.length) params.markets = String(markets);

  if (markets === EmergingMarket.ABBREVIATION && !products?.length) {
    params.products = String([HycProduct.ABBREVIATION, IgcProduct.ABBREVIATION]);
  }

  if (markets?.length && !regions?.length) {
    const marketList = markets.split(',');
    const derivedRegions = Market.getRegionsByMarkets(marketList).map((r) => r.getAbbreviation());
    params.regions = String(derivedRegions);
  }

  return new URLSearchParams(params).toString();
};
